import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class IonicScrollManagerService {
  private readonly router = inject(Router);

  public navigateAndScrollToTop(path: string | string[], queryParams?: any, animationDuration = 500): Promise<boolean> {
    return this.router.navigate(typeof path === 'string' ? [path] : path, { queryParams }).then((success: boolean) => {
      if (success) {
        setTimeout(() => {
          this.scrollToTop(animationDuration);
        }, 150);
      }
      return success;
    });
  }

  public scrollToTop(animationDuration = 500): void {
    const ionContents = document.querySelectorAll('ion-content');

    ionContents.forEach((content, i) => {
      const rect = content.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

      if (isVisible) {
        // try {
        (content as any).scrollToTop(animationDuration);
        // } catch (e) {
        // console.error(`[ScrollManager] Error en ion-content #${i}:`, e);
        // }
      }
    });
  }
}
